import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(LocalizedFormat)

import 'dayjs/locale/ja'
dayjs.locale('ja')
